export default __webpack_public_path__ + "assets/edit-pencil.9bd693a3.svg";